import BurguerIcon from './BurguerIcon';

export default BurguerIcon;
